import { getBpsStage, parseStage } from './features';

/** Pre-launch site password gate; enabled for non-public deploy targets only. */
export function isSiteAccessGateEnabled(): boolean {
  const configuredStage = parseStage(import.meta.env.VITE_STAGE);
  if (import.meta.env.VITE_STAGE && !configuredStage) {
    return true;
  }
  const stage = getBpsStage();
  return stage !== 'local' && stage !== 'production';
}
